import UserList from '../components/user/UserList';

import { PageTitle } from '../../../../_metronic/layout/core';

export default function UsersPage() {
  return (
    <>
      <PageTitle>DevOps - Gerenciamento de Usuários</PageTitle>
      <UserList />
    </>
  );
}
